import React, { useEffect, useState, FC } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { isAuth } from "../../../pages/auth/ProtectedRoute";
import MentorshipPendingTable from "./Tables/MentorshipPendingTable";
import MentorshipApprovedTable from "./Tables/MentorshipApprovedTable";

const MentorshipManagementTab: FC = () => {
  const [pendingTotal, setPendingTotal] = useState<number>(0);
  const [approvedTotal, setApprovedTotal] = useState<number>(0);

  const getPendingTotal = (newValue: number) => {
    setPendingTotal(newValue);
  };

  const getApprovedTotal = (newValue: number) => {
      setApprovedTotal(newValue);
  }

  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `mentor-profiles?status=approved`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true && res.data.status === 200) {
          setApprovedTotal(res?.data?.data?.pagination?.total || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="task-dashboard" style={{ padding: "40px" }}>
      <div className="project-table" style={{ 
        display: "flex", 
        flexDirection: "column",
      }}>
        <Tabs style={{ flex: 1 }}>
          <TabList
            style={{
              borderBottom: "none",
              margin: 0,
              display: "flex",
              alignItems: "center"
            }}
          >
            <Tab className="project-tab">
              <span className="tab-label">Pending Approval</span>
              <span className="tab-count">{pendingTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Approved</span>
              <span className="tab-count">{approvedTotal}</span>
            </Tab>
          </TabList>
          <TabPanel className="pending-button">
            <MentorshipPendingTable getPendingTotal={getPendingTotal} />
          </TabPanel>
          <TabPanel className="approval-button">
            <MentorshipApprovedTable getApprovedTotal={getApprovedTotal}/>
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
export default MentorshipManagementTab;
